import api from "../api/api";

// FETCH ALL
export const fetchDiscountCodes = () => async (dispatch) => {
    try {
        dispatch({ type: "DISCOUNT_CODES_FETCH_REQUEST" });
        const codes = await new Promise((resolve) => {
            api.getAllDiscountCodes("", resolve);
        });
        dispatch({ type: "DISCOUNT_CODES_FETCH_SUCCESS", payload: codes });
    } catch (error) {
        dispatch({ type: "DISCOUNT_CODES_FETCH_FAILURE", error });
    }
};

// CREATE
export const addDiscountCode = (data) => async (dispatch) => {
    try {
        dispatch({ type: "DISCOUNT_CODE_ADD_REQUEST" });
        const code = await new Promise((resolve) => {
            api.addDiscountCode(data, resolve);
        });
        dispatch({ type: "DISCOUNT_CODE_ADD_SUCCESS", payload: code });
    } catch (error) {
        dispatch({ type: "DISCOUNT_CODE_ADD_FAILURE", error });
    }
};

// DELETE
export const deleteDiscountCode = (id) => async (dispatch) => {
    try {
        dispatch({ type: "DISCOUNT_CODE_DELETE_REQUEST", payload: id });
        await new Promise((resolve) => {
            api.deleteDiscountCode(id, resolve);
        });
        dispatch({ type: "DISCOUNT_CODE_DELETE_SUCCESS", payload: id });
    } catch (error) {
        dispatch({ type: "DISCOUNT_CODE_DELETE_FAILURE", error });
    }
};

// UPDATE
export const updateDiscountCode = (id, data) => async (dispatch) => {
    try {
        dispatch({ type: "DISCOUNT_CODE_UPDATE_REQUEST", payload: id });
        const updated = await new Promise((resolve) => {
            api.updateDiscountCode(id, data, resolve);
        });
        dispatch({ type: "DISCOUNT_CODE_UPDATE_SUCCESS", payload: updated });
    } catch (error) {
        dispatch({ type: "DISCOUNT_CODE_UPDATE_FAILURE", error });
    }
};
